import React, { useContext, useState } from 'react';
import { Modal, Image, ListGroup, Form, Button } from 'react-bootstrap';
import './productModal_styles.css'
import './styles_upload.css'
import { IoIosArrowForward, IoIosArrowBack, IoIosClose  } from "react-icons/io";
import useReasonList from '../../../hook/useReasonList';
import useReasonSet from '../../../hook/useReasonSet';
import { OrderContext } from '../../../context/OrderContext';
import useClaimTypeSet from '../../../hook/useClaimTypeSet';
import { useNavigate } from 'react-router-dom';
import useCreateRefund from '../../../hook/useCreateRefund';
import useCompleteClaim from '../../../hook/useCompleteClaim';
import { BsUpload } from 'react-icons/bs';
import usePhotoUpload from '../../../hook/usePhotoUpload';
import { toast } from 'react-toastify';
import { AiOutlineDelete } from "react-icons/ai";
import useRefundConfirmationEmail from '../../../hook/useRefundConfirmationEmail';



const ProductModal = ({  showModal, handleClose, product, setShowModal }) => {

  const [content, setContent] = useState('followUp');
  const [note, setNote] = useState('')
  const MAX_FILE_SIZE_MB = 5;
  const {dataReason, reason} = useReasonList();  //reason hook
  const {postReason} = useReasonSet()
  const {postClaim} = useClaimTypeSet()
  const {dataProducts} = useCreateRefund()
  const {completeClaim} = useCompleteClaim()
  const { uploadFile } = usePhotoUpload();
  const { sendConfirmationEmail } = useRefundConfirmationEmail();


  const {setClaimType, orderNumber, email, uuid} = useContext(OrderContext);

  const navigate = useNavigate();


  // Sadece iade aktif - değişim özelliği kullanılmıyor
  const followUps = [
    // { id: 1, value: 'Değişim Talep Ediyorum' }, // Değişim özelliği comment'lendi
    { id: 0, value: 'İade Talep Ediyorum' }
  ];


  const handleFollowUpClick = (followUpId) => {
    setClaimType(followUpId);
    postClaim(followUpId, product.Id)
    setContent('reason'); 
    dataReason(product.Id)
  };


  // useEffect(() => {
  //     dataReason(product.Id);
  // }, [showModal]);

  const handleCloseAndReset = () => {
    handleClose(); 
    setContent('followUp');

  };

  const handleReasonClick = (reason) => {
    postReason(reason.Id, product.Id) 
    setContent('upload'); 
  };

  const goBack = () => {
    setContent('followUp');
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const getLatestClaimIdForProduct = (claims, productId) => {
    if (!Array.isArray(claims)) return null;
    const relatedClaims = claims.filter((claim) => {
      if (!claim?.items || !Array.isArray(claim.items)) return false;
      return claim.items.some((item) => item?.order_product?.Id === productId);
    });
    if (!relatedClaims.length) return null;
    return relatedClaims.reduce((maxId, claim) => Math.max(maxId, Number(claim?.Id) || 0), 0) || null;
  };


  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024;
      if (file.size === 0) {
        toast.error("Dosya bos olamaz!");
        setSelectedFile(null);
        setFileName('');
        event.target.value = '';
        return;
      }
      if (file.size > maxFileSize) {
        toast.error(`Dosya boyutu en fazla ${MAX_FILE_SIZE_MB} MB olabilir!`);
        setSelectedFile(null);
        setFileName('');
        event.target.value = '';
        return;
      }
      setSelectedFile(file);
      setFileName(file.name); // Seçilen dosyanın adını ayarlayın
    }
  };

  const handleUpload = async () => {
    
    if (!note) {
      toast.error("Lütfen açıklama giriniz!");
      return;
    }

    if (!selectedFile) {
      toast.error("Lütfen dosya yükleyiniz!");
      return;
    }
  
    const maxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (selectedFile.size === 0) {
      toast.error("Dosya bos olamaz!");
      return;
    }
    if (selectedFile.size > maxFileSize) {
      toast.error(`Dosya boyutu en fazla ${MAX_FILE_SIZE_MB} MB olabilir!`);
      return;
    }
  
    let completeResult;
    try {
      const response = await uploadFile(selectedFile, product.Id);

      if (!response?.message) {
        toast.error("Dosya yuklenemedi.");
        return;
      }

      toast.success("Dosya basariyla yuklendi!");
      completeResult = await completeClaim(product.Id, note);
      await dataProducts(orderNumber, email);
    } catch (error) {
      toast.error(error.message || "Dosya yukleme hatasi olustu.");
      return;
    }
    
    // Her yeni claim için tekil mail gönder
    if (uuid) {
      const claimId = getLatestClaimIdForProduct(completeResult?.claims, product.Id);
      const dedupeKey = claimId ? `${uuid}-${claimId}` : `${uuid}-${product.Id}-${Date.now()}`;
      sendConfirmationEmail(uuid, { dedupeKey });
    }
    
    setShowModal(false)
    setContent('followUp'); 
  };

  const handleFileDelete = () =>{
    setSelectedFile(null)
    setFileName('')
    // console.log("calıştı")
  }


  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  // console.log("note", note)


  const renderContent = () => {
    switch (content) {
      case 'reason':
        return (
          <ListGroup variant="flush" className='mt-3'>
             <p>Ürün iade etme nedenini seçiniz.</p>
             {Array.isArray(reason) && reason.map((reasonItem, index) => (
            <ListGroup.Item key={index} action onClick={() => handleReasonClick(reasonItem)} className='type-list'>
              {reasonItem.Name}
              <IoIosArrowForward className="float-end" /> 
            </ListGroup.Item>
          ))}
          </ListGroup>
        );
      case 'followUp':
        return (
          <ListGroup variant="flush" className='mt-4'>
            {followUps.map((followUp, index) => (
              <ListGroup.Item key={index} action onClick={() => handleFollowUpClick(followUp.id)}  className='type-list'>
                {followUp.value}
                <IoIosArrowForward className="float-end" /> 
              </ListGroup.Item>
            ))}
          </ListGroup>
        );
        case 'upload':
          return (
            <div className="upload-section">
              <Form>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label className='form-title'>Açıklama (Zorunlu)</Form.Label>
                  <Form.Control 
                    className='text-area' 
                    as="textarea" 
                    rows={3} 
                    placeholder="Konuyla ilgili detayları burada belirtebilirsiniz" 
                    value={note}
                    onChange={handleNoteChange}
                  />
                </Form.Group>

                <Form.Group controlId="formFileUpload" className="mb-3">
                  <Form.Label className='form-title'>Ürün Fotoğrafları / Rapor (Zorunlu)</Form.Label>
                  <p className='title-description'>
                    Talebinizi açıklayan <span>görsel</span>, <span>kargo tutanağı</span> veya <span>servis raporu</span> ekleyiniz.
                  </p>
                  <div className="upload-area">
                    <input type="file" onChange={handleFileSelect} accept="image/*,.pdf" required />
                    <BsUpload className="upload-icon" />
                    <p className="upload-hint">Dosya seçmek için tıklayın</p>
                  </div>
                  {fileName && (
                    <div className='file-area'>
                      <p className="file-name">{fileName}</p>
                      <button 
                        type="button"
                        onClick={handleFileDelete}
                        className="file-delete-btn"
                        aria-label="Dosyayı sil"
                      >
                        <AiOutlineDelete />
                      </button>
                    </div>
                  )}
                </Form.Group>
                <Button className='submit-button' onClick={handleUpload}>
                  Onayla ve Gönder
                </Button>
              </Form>
            </div>
          );
      default:
        return null;
    }
  };

  return (
    <Modal show={showModal} onHide={handleCloseAndReset} size="lg" centered className="product-modal-new">
      <Modal.Body className="modal-body-new">
        {/* Header with back and close buttons */}
        <div className="modal-header-new">
          {content !== 'followUp' && (
            <button onClick={goBack} className="modal-btn-back" aria-label="Geri">
              <IoIosArrowBack />
            </button>
          )}
          <button onClick={handleCloseAndReset} className="modal-btn-close" aria-label="Kapat">
            <IoIosClose />
          </button>
        </div>

        {/* PC'de yan yana, mobilde dikey layout */}
        <div className="modal-layout-container">
          {/* Product Image */}
          <div className="modal-product-image-wrapper">
            <Image src={product.image} alt={product.Name} className="modal-product-image" />
          </div>

          {/* Content */}
          <div className="modal-content-wrapper">
            {renderContent()}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductModal;
